import React from 'react'

import NavBar from '../../modules/usuario/components/NavBar/NavBar'
import SideDrawer from '../../modules/usuario/components/SideDrawer/SideDrawer'
import CadastrarAssociado from '../CadastrarAssociado'

export default function CadastrarAssociadoPublico() {
    return (
        <>
            <NavBar />
            <SideDrawer permissao={1}>
                <CadastrarAssociado />
            </SideDrawer>
        </>
    )
}
